import React from "react";
import styled from "styled-components";

export default function FullButton({ title, action, border }) {
  return (
    <Wrapper
      className="animate pointer radius8"
      onClick={action ? () => action() : null}
      border={border}
    >
      {title}
    </Wrapper>
  );
}

const Wrapper = styled.button`
  border: 1px solid ${(props) => (props.border ? "#7620ff" : "#7620ff")};
  background-color: ${(props) => (props.border ? "transparent" : "#7620ff")};
  width: 100%;
  padding: 15px;
  outline: none;
  color: ${(props) => (props.border ? "#7620ff" : "#fff")};
  :hover {
    background-color: ${(props) => (props.border ? "transparent" : "#7620ff")};
    border: 1px solid #5272ff;
    color: ${(props) => (props.border ? "#7620ff" : "#fff")};
  }
`;

